import {
  Badge,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import i18n from 'i18next'
//import { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { matchPath } from 'react-router'
import { NavigationItem } from '../types'

type ActionFunc = (arg?: any) => void

interface MenuItemsProps {
  navigate: ActionFunc
  openDialog: ActionFunc
  closeDrawer: ActionFunc
  menuItems: NavigationItem[]
  classes: any
  children?: any
  navPath: string
  t: i18n.TFunction
  setCurrentKey: any
  unreadMessages: number
}

const menuStyles = () => ({
  menuItem: {
    marginLeft: 10,
    marginRight: 10,
    height: '10vh',
    fontSize: '2rem'
  }
})

const isPathSelected = (menuPath: string) => {
  const currentPath = window.location.pathname

  if (menuPath === '/apartments') {
    return currentPath === '/apartments'
  }

  if (menuPath === '/showings/overview') {
    return currentPath.includes('/showings/overview')
  }

  return currentPath.includes(menuPath) && !currentPath.includes('/showings/overview')
}

const runClick = (
  navigate: ActionFunc,
  closeDrawer: ActionFunc,
  id: string,
  url: any = ''
) => {
  navigate(url + id)
  closeDrawer()
}

const MenuItems = ({
  navigate,
  closeDrawer,
  menuItems,
  classes,
  children,
  t,
  setCurrentKey,
  unreadMessages
}: MenuItemsProps) => {
  const mathcedUrl: any = matchPath(window.location.pathname, {
    path: '/users/:userId/apartments/:apartmentId'
  })

  const BadgeIcon = ({ children, rootId }: any) => {
    const safeUnread = Number.isFinite(unreadMessages as any)
      ? Number(unreadMessages)
      : 0
    return (
      <>
        {rootId === '/messages' ? (
          <Badge
            badgeContent={safeUnread}
            color='primary'
            invisible={!safeUnread}
          >
            {children}
          </Badge>
        ) : (
          <>{children}</>
        )}
      </>
    )
  }

  return (
    <MenuList>
      {children}
      {menuItems.map(({ id, label, icon: Icon }) => {
        if (
          mathcedUrl?.params?.apartmentId &&
          mathcedUrl?.params?.userId &&
          (id === '/applications' ||
            id === '/showings/overview' ||
            id === '/overview' ||
            id === '/messages')
        ) {
          return (
            <MenuItem
              className={classes.menuItem}
              key={id}
              selected={isPathSelected(id)}
              onClick={() => {
                runClick(navigate, closeDrawer, id, mathcedUrl.url)
                setCurrentKey(id)
              }}
            >
              <ListItemIcon>
                <BadgeIcon rootId={id}>
                  <Icon />
                </BadgeIcon>
              </ListItemIcon>
              <ListItemText primary={t(label)} />
            </MenuItem>
          )
        } else if (
          (!(mathcedUrl?.params?.apartmentId && mathcedUrl?.params?.userId) &&
            (id === '/profile' || id === '/tenants')) ||
          id.toLowerCase().includes('apartments')
        ) {
          return (
            <MenuItem
              className={classes.menuItem}
              key={id}
              selected={isPathSelected(id)}
              onClick={() => {
                runClick(navigate, closeDrawer, id)
                setCurrentKey(id)
              }}
            >
              <ListItemIcon>
                <BadgeIcon rootId={id}>
                  <Icon
                    style={
                      id.toLowerCase().includes('apartments')
                        ? {
                          filter: 'invert(100%)'
                        }
                        : {}
                    }
                  />
                </BadgeIcon>
              </ListItemIcon>
              <ListItemText primary={t(label)} />
            </MenuItem>
          )
        }
        return null
      })}
    </MenuList>
  )
}

export default withTranslation()(
  withStyles(menuStyles, { withTheme: true })(MenuItems) as any
) as any
